import { types } from 'mobx-state-tree';
import { getBrandingName } from '../index';
export const BrandingProps = types
    .model('BrandingProps', {
        brandingName: types.string, //'tellit'
        displayName: types.string, //'Tellit'
        mainUrl: types.string, // 'http://tellit.se'
        becomeCustomerUrl: types.string, // 'http://tellit.se/hur_fungerar_det'
        getSubscriptionUrl: types.string, // 'http://tellit.se/priser'
        fullPhoneNumber: types.string, // '+46201202882'
        displayPhoneNumber: types.string, // '020-120 28 82'
        mailAddress: types.string, // 'kundsupport@tellit.se'        
    })
    .actions(self => ({        
        setBranding(data) {
            console.log('BrandingProps.setBranding');
            if (data.length > 0) {
                for (let i = 0; i <= data.length - 1; i++) {

                    let name: string = data[i].Name.toString();
                    let value: string = '';
                    //get value
                    if (data[i].Value) {
                        //value from server
                        value = data[i].Value.toString();
                    } else {
                        //no value from server
                        if (name === 'brandingName') {
                            //brandingName is not allowed to be empty
                            //set branding name by host name
                            value = getBrandingName();
                        } else {
                            value = '';
                        }
                    }
                    console.log('BrandingProps.setBranding ' + '[' + i + ']' + 'name = ' + name + ' ' + 'value = ' + value);

                    //set values
                    if (name === 'brandingName') {
                        self.brandingName = value; //'tellit'
                    } else if (name === 'displayName') {
                        self.displayName = value; //'Tellit'
                    } else if (name === 'mainUrl') {
                        self.mainUrl = value; //'http://tellit.se'
                    } else if (name === 'becomeCustomerUrl') {
                        self.becomeCustomerUrl = value; //'http://tellit.se/hur_fungerar_det'
                    } else if (name === 'getSubscriptionUrl') {
                        self.getSubscriptionUrl = value; //'http://tellit.se/priser'
                    } else if (name === 'fullPhoneNumber') {
                        self.fullPhoneNumber = value; //'+46201202882'
                    } else if (name === 'displayPhoneNumber') {
                        self.displayPhoneNumber = value; //'020-120 28 82'
                    } else if (name === 'mailAddress') {
                        self.mailAddress = value; //'kundsupport@tellit.se'
                    }

                    // self.brandingName = 'tellit';
                    // self.displayName = 'Tellit';
                    // self.mainUrl = 'http://tellit.se';
                    // self.becomeCustomerUrl = 'http://tellit.se/hur_fungerar_det';
                    // self.getSubscriptionUrl = 'http://tellit.se/priser';
                    // self.fullPhoneNumber = '+46201202882';
                    // self.displayPhoneNumber = '020-120 28 82';
                    // self.mailAddress = 'kundsupport@tellit.se';
                }
            }

        },


    }));

export default BrandingProps;


// WEBPACK FOOTER //
// ./src/models/BrandingProps.ts